module.exports = __webpack_public_path__ + "img/home-testimonial-bg.e44c1587.jpg";